export const VIEW_ASSIGNMENTS_PAGE = 'VIEW_ASSIGNMENTS_PAGE';
export const VIEW_ASSIGNMENT_PAGE = 'VIEW_ASSIGNMENT_PAGE';
export const CHANGE_SPACE = 'CHANGE_SPACE';
export const FETCH_ASSESSMENT_ITEMS = 'FETCH_ASSESSMENT_ITEMS';
export const EXPORT_GRADES_AS_CSV = 'EXPORT_GRADES_AS_CSV';
export const FETCH_ASSIGNMENTS = 'FETCH_ASSIGNMENTS';
export const FETCH_GRADES_FOR_ASSIGNMENT = 'FETCH_GRADES_FOR_ASSIGNMENT';
export const CLICK_ASSIGNMENT_EXTERNAL_LINK = 'CLICK_ASSIGNMENT_EXTERNAL_LINK';
export const OPEN_MAP_ASSIGNMENTS_MODAL = 'OPEN_MAP_ASSIGNMENTS_MODAL';
export const SAVE_ASSIGNMENT_MAPPINGS = 'SAVE_ASSIGNMENT_MAPPINGS';
export const REMOVE_ASSIGNMENT_MAPPING = 'REMOVE_ASSIGNMENT_MAPPING';
export const SELECT_ASSIGNMENT_MAPPING = 'SELECT_ASSIGNMENT_MAPPING';
export const LOG_OUT = 'LOG_OUT';
export const CREATE_ASSIGNMENT = 'CREATE_ASSIGNMENT';
export const EDIT_ASSIGNMENT = 'EDIT_ASSIGNMENT';
export const DELETE_ASSIGNMENT = 'DELETE_ASSIGNMENT';
export const VIEW_STUDENTS_PAGE = 'VIEW_STUDENTS_PAGE';
export const VIEW_STUDENT_PAGE = 'VIEW_STUDENT_PAGE';
export const OPEN_ASSESSMENT_ITEM_MODAL = 'OPEN_ASSESSMENT_ITEM_MODAL';
export const RELEASE_GRADES = 'RELEASE_GRADES';
export const GRADE_MANUAL_ASSIGNMENT = 'GRADE_MANUAL_ASSIGNMENT';
